import React, { HTMLAttributes, PropsWithChildren } from 'react'

import { cn } from '@/lib/utils'

export const Flex = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
>(({ className, ...rest }, ref) => (
  <div ref={ref} className={cn(['flex', className])} {...rest} />
))

export const Grid = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
>(({ className, ...rest }, ref) => (
  <div ref={ref} className={cn(['grid', className])} {...rest} />
))

export const Container: React.FC<
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
> = ({ className, ...rest }) => (
  <section
    className={cn([
      'mx-auto w-full max-w-[1280px] p-2 xs:p-4 xl:p-10',
      className
    ])}
    {...rest}
  />
)

export const BorderBox: React.FC<
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
> = ({ className, ...rest }) => (
  <div
    className={cn([
      'rounded-md border bg-white/5 p-3 backdrop-blur-md xl:p-4',
      className
    ])}
    {...rest}
  />
)
